import styled from "styled-components";
import { useApp } from "../../contexts";
import Modal from "../Modal/Modal";
import { Divider } from "antd";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .description p {
    margin-bottom: 16px;
  }
`;

export default function ModalAgeIneligible({
  title,
  message,
  description,
  onClose,
  onConfirm,
  ...props
}) {
  const { T } = useApp();

  const renderUpdateIcon = () => {
    return (
      <svg
        width="100"
        height="101"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="49.9999"
          cy="50.9762"
          r="41.6667"
          stroke="#D9D9D9"
          strokeWidth="2"
        />
        <path
          d="M60.4165 40.5597L39.5833 61.3929M39.5832 40.5596L60.4164 61.3928"
          stroke="#EA4848"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    );
  };

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="800px"
        onClose={onClose}
      >
        <ContentWaper>
          <div className="text-black text-center font-bold text-[24px]/[36px] lg:text-[30px]/[45px] lg:h-full">
            {title}
          </div>
          <Divider className="my-6 border-t-2" />
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <div className="flex justify-center items-center mb-6">
                {renderUpdateIcon()}
              </div>
              <div className="text-black font-bold text-center text-[16px]/[24px] lg:text-[24px]/[36px] mb-5 lg:text-[24px]">
                {message}
              </div>
              <div
                className="description mt-[20px] text-[16px]/[24px] lg:text-[24px]/[36px]  justify-center text-center items-center text-black"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              ></div>
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-col-reverse lg:flex-row lg:flex-nowrap justify-center items-center gap-[20px]">
                <button
                  type="button"
                  className="w-full lg:w-[165px] bg-black leading-[56px] !text-white rounded-[56px] lg:rounded-[10px] px-5 h-[56px] text-[16px] lg:text-[24px]"
                  onClick={() => onConfirm?.()}
                >
                  {T("OK")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
}
